module.exports = __webpack_public_path__ + "media/images/athena_powered-6033c167e6cbcae4cbe4ca243bc63d08.png";